// Shared decorative bits for the login panel and the dashboard header.

/** Time-of-day greeting in Russian. */
export function greeting(): string {
  const h = new Date().getHours();
  if (h < 5) return "Доброй ночи";
  if (h < 12) return "Доброе утро";
  if (h < 18) return "Добрый день";
  return "Добрый вечер";
}
